import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var ReadingLevelGraph = require("components/data/ReadingLevelGraph");
var ItemHeader = require("components/data/subjects/shared/ItemHeader");
var EmptyState = require("components/data/EmptyState");
var TruncatedDataNote = require("components/data/TruncatedDataNote");

function propsToBookConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "userIDs"
	);

	conditions.timeKey = "last_active_by_user_id";

	return conditions;
}
function propsToReadingLevelConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "userIDs"
	);

	return conditions;
}


@connect(
	(state, props) => ({
		loading: (
			ReadingSelectors.isLoadingBooks({ state }) ||
			ReadingSelectors.isLoadingReadingLevels({ state })
		),
		books: ReadingSelectors.books({
			state,
			conditions: propsToBookConditions(props),
			showLogs: Features.isEnabled(Features.LOG_READING),
			showDigitalActivities: Features.isEnabled(Features.DIGITAL_EXERCISES)
		}),
		readingLevels: ReadingSelectors.readingLevels({
			state,
			conditions: propsToReadingLevelConditions(props)
		})
	}),
	(dispatch, props) => ({
		populateData: () => {
			// TODO: standardize FE requests
			// if the dataset of students is large, send multiple requests
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = _.pick(props, "startDate", "endDate")
				var actionFunction = ReadingActions.fetchBookActivity
				var options = { embeds: ["book.quiz_evaluations", "book.log_sums"], cache: true, fetchDetails: false }

				return new Promise(function (resolve, reject) {
					// books
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
						var responses = results
						actionFunction = ReadingActions.fetchReadingLevels
						options = {cache: true}
						// reading level
						$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (second_results) {
							var tasks = second_results
							resolve(_.compact(_.flatten(tasks.concat(responses))));
						})
					})
				}).catch(() => console.log("Book activity and reading levels failed to load"));
			} else {
				var booksPromise = dispatch(ReadingActions.fetchBookActivity({
					conditions: propsToBookConditions(props),
					embeds: ["book.quiz_evaluations", "book.log_sums"],
					fetchDetails: false, // We'll load in book details in a second step
					cache: true
				}))

				var readingLevelPromise = dispatch(ReadingActions.fetchReadingLevels({
					conditions: propsToReadingLevelConditions(props),
					cache: true
				}));

				return Promise.all([booksPromise, readingLevelPromise]);
			}
		},

		fetchBookDetails: (textIDs) => {
			return dispatch(ReadingActions.fetchBooks({
				ids: textIDs, 
				userID: CurrentUser.get().id,
			}));
		}
	})
)
@providePopulateData()
class DataReadingLevelGraph extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("DataReadingLevelGraphs");
	}

	getBooks(studentID) {
		return _.select(this.props.books, (book) => {
			return _.includes(book.user_ids, studentID)
		});
	}

	getUserIDs() {
		var userIDs = this.props.userIDs;
		if (this.props.studentLimit) {
			userIDs = _.sortBy(userIDs, (studentID) => {
				var recentBook = _.sortBy(_.map(this.getBooks(studentID)), (book) => {
					if (book.last_actives) {
						return book.last_actives[studentID];
					}
				}).reverse()[0];

				if (recentBook && recentBook.last_actives) {
					return recentBook.last_actives[studentID];
				} else {
					return "1970-01-01";
				}
			}).reverse()
			userIDs = _.first(userIDs, this.props.studentLimit);
		}
		return userIDs;
	}

	render() {

		if (this.props.userIDs && this.props.userIDs.length == 0) {
			var emptyState = <EmptyState type={ RL_GRAPH } />
		} else {
			if (this.props.showFullData) {
				var userIDs = this.getUserIDs()
			} else {
				var userIDs = _.first(this.getUserIDs(), 3)
				var truncatedRow = <TruncatedDataNote type={ RL_GRAPH } />
			}
			var display = _.map(userIDs, (studentID) => {
				var books = this.getBooks(studentID);

				var readingLevels = _.where(this.props.readingLevels, { student_id: studentID });

				var header = (
					<ItemHeader studentID={ studentID } pageBreak />
				);

				return (
					<div className='studentReadingLevelGraph' key={ studentID }>
						{ header }
						<ReadingLevelGraph studentID={ studentID }
							numMonths={ this.props.numMonths }
							readingLevels={ readingLevels } books={ books } />
					</div>
				);
			});
		}

		return (
			<div className="dataReadingLevelGraph">
				{ display }
				{ emptyState }
				{ truncatedRow }
			</div>
		)
	}

	componentDidMount() {
		var textIDs = _.uniq(_.flatten(_.map(this.getUserIDs(), (userID) => {
			return _.pluck(this.getBooks(userID), "text_id");
		})));

		this.props.fetchBookDetails(textIDs);
	}
}
var RL_GRAPH = "reading-level-graph";
DataReadingLevelGraph.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showFullData: PropTypes.bool,
	studentLimit: PropTypes.number,
	numMonths: PropTypes.number,

	// Data from @connect
	loading: PropTypes.bool,
	books: PropTypes.array,
	readingLevels: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
	fetchBookDetails: PropTypes.func
})

module.exports = DataReadingLevelGraph;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataReadingLevelGraphs.js